// extracted by mini-css-extract-plugin
export default {"RankPill":"RankPill_RankPill__5vIHm"};